import $ from 'jquery';
import Tooltip from './tooltip';
import 'sumoselect';

import BgLightHeader from './bg-light-header';
/* global x5script */

class Posts {
  constructor() {
    this.posts = $('.js-posts');

    if (!this.posts.length) {
      return;
    }

    this.tooltip = new Tooltip();
    this.bgLightHeader = new BgLightHeader();

    this.displayType = this.posts.data('posts-display-type') || 'blog';
    this.offset = this.posts.data('initial-offset');
    this.limit = this.posts.data('posts-count');
    this.postsPerLoad = this.posts.data('posts-per-load');
    this.selectedPillar = this.posts.data('blog-pillar');
    this.selectedCategory = this.posts.data('blog-category');
    this.selectedTag = this.posts.data('blog-tag');
    this.loading = false;

    this.filterSelect = $('.js-blog-filter-select');

    this.loadMore();
    this.filters();
    this.bgLightHeader.init();
  }

  loadMore() {
    this.loadMoreDiv = $('.js-blog-load-more');
    this.loadMoreBtn = this.loadMoreDiv.find('.js-blog-load-more-button');
    this.loader = this.loadMoreBtn.find('.js-loader');

    this.loadMoreBtn.on('click', () => {
      if (this.loading) {
        return;
      }

      if (
        this.posts.hasClass('c-reports') &&
        window.innerWidth <= 480 &&
        this.loadMoreBtn.length > 0
      ) {
        const articlesList = this.posts.find('.c-reports__list');

        if (articlesList.length && !articlesList.hasClass('is-loaded')) {
          articlesList.addClass('is-loaded');
          return;
        }
      }

      const error = this.loadMoreDiv.find('.js-blog-posts__error');

      if (error.length) {
        error.remove();
      }

      this.loadMoreBtn.attr('disabled', true);
      this.loader.show();

      this.loadMorePosts();

      this.loading = true;
    });
  }

  loadMorePosts() {
    const ajaxData = {
      action: 'x5_load_more_posts',
      offset: this.offset,
      display: this.displayType,
      ppl: this.postsPerLoad,
      pillar: this.selectedPillar,
      category: this.selectedCategory,
      tag: this.selectedTag,
      security: x5script.security,
    };

    $.post(x5script.ajaxurl, ajaxData, response => {
      if (response.ok) {
        this.offset = response.offset;

        this.displayPosts(response.posts);

        if (this.offset >= this.limit) {
          this.loadMoreDiv.hide();
          this.posts.addClass('has-loaded-all');
        }
      } else if (response.error) {
        // eslint-disable-next-line no-console
        this.loadMoreDiv.append(
          `<p class="c-blog-posts__error js-blog-posts__error">${
            response.error
          }</p>`,
        );
      }

      this.loading = false;
      this.loadMoreBtn.attr('disabled', false);
      this.loader.hide();
    }).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  }

  displayPosts(data) {
    let posts = ``;

    $.each(data, (i, post) => {
      const isFirstClass = i === 0 ? 'is-first' : '';

      if (this.displayType === 'report') {
        posts += `
        <article id="post-${
          post.id
        }" class="c-report o-layout__item o-layout__item--medium-4 js-blog-item ${
          post.class
        } ${isFirstClass}">
          <div class="c-report__inner">
            <span class="c-report__color-bar" style="background-color:${
              post.color
            }"></span>
            <h5 class="c-report__title"><a href="${
              post.link
            }" class="c-report__link">${post.title}</a></h5>
            <time class="c-report__date" datetime="${post.date_attr}">${
          post.date
        }</time>

            ${post.pillar}
          </div>
        </article>
        `;
      } else {
        posts += `
        <article id="post-${post.id}" class="${
          post.class
        } o-layout__item o-layout__item--medium-4 js-blog-item c-blog-item ${isFirstClass}">
          <a href="${post.link}" class="c-blog-item__inner">
            <header class="o-layout c-blog-item__header">
              <h2 class="c-blog-item__title">${post.title}</h2>
            </header>

            <div class="c-blog-item__image">
              <div class="c-blog-item__thumbnail">${post.thumbnail}</div>
              ${post.categoryIcons}
              ${post.pillarCard}
            </div>
          </a>
        </article>
        `;
      }
    });

    $(posts).insertBefore(this.loadMoreDiv);
    this.tooltip.init();
    this.bgLightHeader.init();

    const firstNew = $('.js-blog-item.is-first');

    $('body, html')
      .stop()
      .animate(
        {
          scrollTop: firstNew.offset().top - 50,
        },
        300,
        () => {
          firstNew.removeClass('is-first');
        },
      );
  }

  filters() {
    if (!this.filterSelect.length) {
      return;
    }

    $.each(this.filterSelect, (i, el) => {
      const select = $(el);

      const sumoSelect = select.SumoSelect({ showTitle: false });

      const checkSelected = () => {
        if (select.val().length > 0) {
          sumoSelect.parentNode.classList.add('selected');
        }
      };

      select.on('change', e => {
        const self = $(e.currentTarget);
        const form = self.closest('form');

        this.filterSelect.not(self).val('');

        checkSelected();

        if (form.length) {
          form.submit();
        }
      });

      checkSelected();
    });
  }
}

export default new Posts();



// WEBPACK FOOTER //
// ./src/scripts/modules/posts.js